// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.map-layer-legend[data-v-490b2262] {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n.legend-dot[data-v-490b2262] {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-right: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
